<template>
  <div class="order-details-wrapper p-0">
    <portal target-el="#filter">
      <div class="breadcrumb">
        <div class="back-option">
          <a href="javascript:history.go(-1)">
            <svgicon
              name="arrow-down"
              class="icon"
              width="17"
              height="17"
              :original="true"
            />
          </a>
        </div>
        <div>
        </div>
      </div>
    </portal>
      <div class="panel-card panel-card-full card-lg clearfix mt-m20">
        <div class="card-left bg-grey-gradient p-0">
           <div class="text-center p-10">
            <div class="menu-profile-icon position-relative">
              <div class="image-holder position-absolute">
                <img :src="imageUrl" class="profile-img" alt=""/>
              </div>
              <div class="position-bc" v-if="!imageUrl" @click="toggleShow">
                <svgicon
                name="icon-edit-md"
                class="icon"
                width="10"
                height="10"
                :original="true"
                />
              </div>
              <div class="position-bc" v-else @click="deletion">
                <svgicon
                name="icon-delete-md"
                class="icon"
                width="10"
                height="10"
                :original="true"
                />
              </div>
            </div>
              <h4 class="text-sm">{{username}}</h4>
          </div>
           <div class="card-list mb-0 no-bg boxshadow-none" @click="switchView('configuration')" :class="{'active': view === 'configuration'}">
              <h5 class="title py-15 px-30 clearfix">
                <div>
                  <span class="text-blue-dark1">{{$t('TRANSPORTER_PROFILE_CONFIGURATIONS')}}</span>
                </div>
              </h5>
            </div>
            <div class="card-list mb-0 boxshadow-none no-bg" @click="switchView('certifications')" :class="{'active': view === 'certifications'}">
              <h5 class="title py-15 px-30 clearfix">
                <div>
                  <span class="text-blue-dark1">{{$t('TRANSPORTER_PROFILE_CERTIFICATIONS')}}</span>
                </div>
              </h5>
            </div>
        </div>
        <div class="card-right ml-m5 bg-white without-scroll p-0">
           <div class="flex-container align-top py-15 px-30 bg-grey-light">
            <div class="flex-item d-flex">
              <div>
                <h4 class="text-sm">{{$t('TRANSPORTER_PROFILE_CONTACT')}}</h4>
                <p class="my-5">{{email}}</p>
                <p class="my-5">{{mobile}}</p>
              </div>
              <!-- Commented for future purpose -->
              <!-- <div v-else>
                  <h4 class="text-sm">{{$t('CONTACT')}}</h4>
                <Input placeholder="Email" size="mini"
                type="text" class="mb-5"></Input>
                <Input placeholder="Contact" size="mini"
                type="text" class="mb-5"></Input>
              </div> -->
            </div>
          </div>
          <div class="card-content d-block boxshadow-none" style="margin-bottom:0px !important; max-height: 64vh; overflow-y:auto; overflow-x: hidden;">
            <div class="inner-left" v-if="!isDataLoading">
              <configuration v-if="view === 'configuration'"
              @update-lr="updateLR"
              @deactivate-lr="deactivateLR"
              :lorryReceiptData="lrList" />
              <certifications ref="certifications" v-else
              :certificates="getCertifications"
              @upload-certification="uploadCertification"
              @update-certification="updateCertification" />
            </div>
          </div>
        </div>
      </div>
    <div class="text-middle" v-if="show">
          <div class="text-inner">
            <div
            class="profile-name"
            >
              <my-upload
                @crop-success="cropSuccess"
                @src-file-set="srcFileSet"
                v-model="show"
                :width="46"
                :height="46"
                lang-type="en"
                img-format="jpeg"
              >
              </my-upload>
            </div>
          </div>
        </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import myUpload from 'vue-image-crop-upload';
import configuration from '../../profile/Configuration';
import certifications from '../../profile/Certifications';

export default {
  components: {
    configuration,
    certifications,
    'my-upload': myUpload,
  },
  data() {
    return {
      view: 'configuration',
      username: '',
      mobile: '',
      email: '',
      imageUrl: null,
      show: false,
      fileName: '',
      fileType: '',
    };
  },
  computed: {
    ...mapState('profile', ['isLrLoading', 'isLoading']),
    ...mapGetters({
      lrList: 'profile/lrList',
      currentUser: 'app/currentUser',
      currentTransporter: 'app/currentTransporter',
      certifications: 'profile/certifications',
    }),
    isDataLoading() {
      return this.isLrLoading;
    },
    getCertifications() { // Computed property to manually inject the updated mapGetters to props
      return !this.isLoading ? this.certifications : this.certifications;
    },
  },
  async created() {
    this.$store.dispatch('profile/lrList');
    this.$store.dispatch('profile/getCertifications');
    this.$store.dispatch('profile/getRoles');
    this.initializeData();
  },
  methods: {
    /**
     * Emit-Catch Handler for uploading certificate files
     */
    async uploadCertification(data) {
      try {
        const formData = new FormData();
        formData.append('attachment', data.attachment_url);
        const result = await this.$store.dispatch(
          'profile/uploadCertification',
          formData,
        );
        if (result && result.id) {
          this.$refs.certifications.updateAttachmentUrl(data.type, result);
        }
      } catch (err) {
        const apiError = err && err.data && (err.data.messages || (err.data.errors && err.data.errors[0] && err.data.errors[0].messages));
        this.$errorMessage({ message: apiError || this.$getErr('UPLOAD_FAILS'), description: apiError });
      }
    },
    /**
     * Emit-Catch Handler for updating certificate details
     */
    async updateCertification(update) {
      try {
        const data = this.extractParameters(update);
        const result = await this.$store.dispatch(
          'profile/updateCertification',
          { data },
        );
        if (result.fssai) {
          this.$success({ message: this.$getSuccess('CERTIFICATE_UPDATED') });
          const response = await this.$store.dispatch('profile/getCertifications');
          this.$refs.certifications.certificationData = { ...response };
        } else {
          this.$error({ message: this.$getErr('CERTIFICATE_UPDATE_ERROR') });
        }
      } catch (e) {
        this.$errorMessage({ message: this.$getErr('APP_CATCH_ERR') });
      }
    },
    /**
     * Helper handler for updateCertification()
     */
    extractParameters(data) {
      const duplicateCertifications = { ...data };
      Object.keys(duplicateCertifications).forEach((key) => {
        if (duplicateCertifications[key].attachment_id === '') {
          delete duplicateCertifications[key].attachment_id;
        }
        delete duplicateCertifications[key].attachment_url;
      });
      return duplicateCertifications;
    },
    async confirmationBox(text, buttonText) {
      return this.$PromptConfirm(text, 'Confirmation', {
        confirmButtonText: buttonText,
        showCancelButton: true,
        lockScroll: true,
        showClose: false,
        center: true,
      });
    },
    /**
     * Handler to set initial data onload
     */
    initializeData() {
      this.username = this.currentUser.name;
      this.mobile = this.currentUser.mobile;
      this.email = this.currentUser.email;
      this.imageUrl = this.currentTransporter.logo_url;
    },
    switchView(view) {
      this.view = view;
    },
    /**
     * Emit-Catch Handler for updating LR details
     */
    async updateLR(lrData) {
      const result = await this.$store.dispatch('profile/updateLR', lrData);
      if (result.data && result.data.errors) {
        this.$error({
          message: result.data.errors.map(error => error.message).join(','),
        });
      } else {
        this.$success({ message: this.$getSuccess('PROFILE_LR_UPDATED') });
      }
    },
    /**
     * Emit-Catch Handler for deactivation of LR
     */
    async deactivateLR(lrData) {
      try {
        const result = await this.$store.dispatch(
          'profile/deactivateLr',
          lrData,
        );
        if (result.status === 500) {
          this.$error({ message: `LR Update failed - ${result.statusText}` });
        }
        if (result.data && result.data.errors) {
          this.$error({
            message: result.data.errors.map(error => error.message).join(','),
          });
        }
        if (result.status === 200) {
          this.$success({
            message: this.$getSuccess('PROFILE_LR_DEACTIVATED'),
          });
        }
      } catch (error) {
        this.$error({ message: 'LR Update failed' });
      }
    },
    /**
     * Handler to delete profile logo
     */
    async deletion() {
      try {
        const confirmApprove = await this.confirmationBox(
          'You are sure you want to Delete',
        );
        if (confirmApprove === 'confirm') {
          const result = await this.$store.dispatch('app/deleteLogo');
          if (result === 'success') {
            this.$successMessage({
              message: this.$getSuccess('LOGO_DELETED_SUCCESS'),
            });
            this.imageUrl = '';
          }
          return true;
        }
        return false;
      } catch (err) {
        return false;
      }
    },
    cropSuccess(imgDataUrl, field) {
      this.uploadLogo(imgDataUrl, field);
      this.show = false;
    },
    toggleShow() {
      this.show = true;
    },
    srcFileSet(fileName, fileType) {
      this.fileName = fileName;
      this.fileType = fileType;
    },
    /**
     * Handler to update profile logo
     */
    async uploadLogo(imgDataUrl) {
      try {
        const res = await fetch(imgDataUrl);
        const blob = await res.blob();
        const formData = new FormData();
        const filedata = new File([blob], this.fileName, {
          type: this.fileType,
        });
        formData.append('attachment', filedata);
        const result = await this.$store.dispatch('app/uploadLogo', formData);
        if (result.url) {
          this.imageUrl = result.url;
          this.$successMessage({
            message: this.$getSuccess('LOGO_UPDATED_SUCCESS'),
          });
        } else {
          this.$errorMessage({ messge: this.$getErr('500') });
        }
      } catch (err) {
        this.$errorMessage({ message: this.$getErr('APP_CATCH_ERR') });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.order-details-wrapper {
  background: none;
  .image-holder {
    top: 0;
    left: 0;
    .profile-img {
      border-radius: 50%;
    }
  }
}
</style>

